import * as React from 'react';

import { PhoneButtonDesktop } from '../../components/PhoneButton';
import { usePhoneButton } from './hooks/usePhoneButton';

export const PhoneButtonDesktopContainer: React.VFC = () => {
  const { handlePhoneShow, phone } = usePhoneButton();

  if (!phone) {
    return null;
  }

  return <PhoneButtonDesktop phone={phone} onPhoneShow={handlePhoneShow} />;
};
